const CS2030TA = {
  jobTitle: "University Teaching Assistant",
  company: "National University of Singapore",
  duration: "Jan 2021 - Apr 2021",
  description:
    "Taught Object-oriented and Functional Programming in a Computing module (CS2030S)",
  jobscope: [
    "Conducted scheduled sessions to facilitate learning of object-oriented/functional programming",
    "Assessed assignments and gave feedback to students' code",
    "Built students' proficiency in Java",
  ],
  funFact:
    "I won an award for this role! Excellence in Teaching based on student ratings.",
};

export default CS2030TA;
